<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script setup>
localStorage.setItem('IframeFlag', false)
</script>

<style  lang="scss">
#app {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  background-color: #F9FAFC;

  .app {
    min-height: 100vh;
    min-width: 100%;
  }

  .products-bg .bg {
    width: 100%;

    img {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }
  }

  .home .box-bg img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
}
</style>